import {
    SupportCaseListResponse,
    useSupportCaseStore,
} from '../../store/supportCaseStore';
import {useEffect} from 'react';

type CaseProviderProps = {
    children: (supportCase: SupportCaseListResponse) => JSX.Element;
    bearer: null | string;
};

const SupportCasesProvider = ({children, bearer}: CaseProviderProps) => {
    const supportCases = useSupportCaseStore(state => state.supportCases);
    const getSupportCases = useSupportCaseStore(state => state.getSupportCases);

    useEffect(() => {
        if (null === bearer || null !== supportCases) {
            return;
        }

        getSupportCases(bearer).then(() => {});
    }, [bearer, supportCases, getSupportCases]);

    if (supportCases !== null) {
        return <>{children(supportCases)}</>;
    }

    return <></>;
};

export default SupportCasesProvider;
